// services/API/menu.js
import commonAPI from "../commonAPI"; // ✅ your axios wrapper

const MenuAPI = {
  getItems: () => commonAPI.get("/menu"),
  addItem: (payload) => commonAPI.post("/menu", payload),
  updateItem: (id, payload) => commonAPI.put(`/menu/${id}`, payload),
  deleteItem: (id) => commonAPI.delete(`/menu/${id}`),
};

export default MenuAPI;
